import React, { useEffect, useState } from "react";
import { currentFps } from "./animation";

// Frame rate, on the bottom strip beside the effects cog and the renderer
// toggle. Always on, and the same for either backend: it counts the map's own
// animation loop, which both of them are driven from.
//
// Sampled on a timer rather than per frame, because re-rendering this on every
// frame would itself be a measurable share of what it is reporting.

const SAMPLE_MS = 500;

// Clear of the effects cog, which sits at right: 118px and is about 25px wide.
const styles = {
  readout: {
    position: "absolute",
    right: "144px",
    bottom: 0,
    zIndex: 1000,
    padding: "4px 8px",
    border: "none",
    borderTopLeftRadius: "6px",
    background: "rgba(0, 0, 0, 0.55)",
    color: "#eee",
    font: "11px/1.45 Consolas, monospace",
    // Digits changing width would make the whole strip twitch once a second.
    fontVariantNumeric: "tabular-nums",
    pointerEvents: "none",
  },
};

const FpsCounter = () => {
  const [fps, setFps] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(
      () => setFps(Math.round(currentFps())),
      SAMPLE_MS
    );
    return () => window.clearInterval(timer);
  }, []);

  return (
    <div style={styles.readout} title="Frames per second">
      {fps} fps
    </div>
  );
};

export default FpsCounter;
